export type dataType = {
  title: string;
  token: string;
  code?: string;
  address_1?: string;
  city_name?: string;
};

export type DebtSite = {
  site_token: string;
  site: string;
  balance: number;
};

export type VisitUserType = { polls: Array<any>; summary: any };

export interface UpdateInnerItem {
  default: number;
  main: null;
  value: string | number;
  items: LookupItem[];
  icon_position: "end" | "start" | undefined;
  title: string;
  icon: null;
  id: string;
  name: string;
  route: string;
  disabled: boolean;
  readonly: boolean;
  rule: "readonly" | "disabled" | "enable";
  show: number;
  type: "text" | "number" | "email" | "password" | "upload" | "switch" | "dropdown" | "richarea" | "autocomplete" | "button" | "date" | "time";
  line: number;
  lookup: string | null;
  required: boolean;
  placeholder: string;
  size: "full" | "half" | "full || half";
  class: string;
  helper: string;
  startIcon: string;
  endIcon: string;
  error: boolean;
  target: string;
}
export interface UpdateMainItem {
  title: string;
  id: string;
  name: string;
  main: any; // Eğer bu değer sadece 'null' veya belirli bir tip olabilecekse, 'any' yerine bu tipi belirtmelisiniz.
  icon: string;
  icon_position: "start" | "end";
  line: number;
  items: UpdateInnerItem[];
}

export type QueryType = {
  company?: string;
  search?: string;
  page?: number;
  paginate?: number;
  site?: string;
  month?: string;
  start?: string;
  end?: string;
  email?: string;
  store?: string;
  status?: string;
};

export type LookupItem = { value: string; label: string; sub?: LookupItem[]; image?: string | null; keyword?: string; disabled?: boolean };

// export type RowListType = Record<string, string[]>;

export type BanksType = {
  id: number;
  company: string;
  site: string;
  store: string;
  title: string;
  holder: string;
  number: string;
  code: string;
  comment: string;
  status: number;
  created_at: string;
  updated_at: string;
  store_info: {
    token: string;
    code: string;
    title: string;
  };
};

export type Navigation = {
  id: number;
  title: string;
  url: string;
  slug: string;
  item: NavItem[];
};

export type NavItem = {
  id: number;
  title: string;
  icon: string | null;
  url: string;
  alt: string | null;
  params: string | null;
  image: string | null;
  sub: NavItem[];
};

export type Store = {
  code: string;
  title: string;
  balance: number;
  credit: string;
  credit_limit: string;
  shop_balance: number;
  shop_credit: string;
  site: string;
  handy_gain: number;
  printer: number;
  address_1: string;
  address_2: string;
  status: number;
  last_sale_at: string;
  last_sale_status: "Active" | "InActive" | "InProgress";
  postal_code: string;
  bonus: string;
  bonus_pin_active: true | false;
  bonus_active: true | false;
  token: string;
  user_name: string;
  city_name: string;
  country_name: string;
  store_card: string;
  print_qr: number;
  device_not_exist: string[];
  not_paid_provision_price?: number;
  not_paid_invoice_price?: number;
  not_paid_return_invoice_price?: number;
  store_operator_info: StoreOperator[];

  id: number;
  company: string;
  type: number;
  note: string | null;
  mwst_office: string | null;
  mwst_number: string;
  city: string;
  country: string;
  tel1_title: string;
  tel1: string;
  email1_title: string;
  email1: string;
  email2_title: string | null;
  email2: string | null;
  faxtitle: string | null;
  fax: string | null;
  website: string | null;
  created_at: string;
  updated_at: string;
  site_name: string;
  site_info: {
    title: string;
    token: string;
  } | null;
};

type StoreOperator = {
  brand: number;
  gain: number;
  brand_info: Brand;
};

export type Site = {
  token: string;
  title: string;
  company: string;
  cdn_url: string;
  logo: string;
  logo_light: string;
  logo_dark: string;
  logo_footer: string;
  copyright: string;
  shop_balance: string;
  css: string;
  navigation: Navigation[];
  phone: string | null;
  whatsapp: string | null;
  sms_login_active: 1 | 0;
  password_login_active: 1 | 0;
  app_login_active: 1 | 0;
};

export type SiteListItem = Pick<Site, "company" | "token" | "title">;

export type Company = {
  token: string;
  title: string;
  status: any;
};

export type Bonus = {
  id: number;
  site: string;
  store: string | null;
  operation: BonusOperation;
  product: string;
  value: number;
  created_at: string | null;
  updated_at: string | null;
  type: "percent" | "amount";
  percent_value: number;
  started_at: string | null;
  ended_at: string | null;
  product_info: {
    id: number;
    token: string;
    title: string;
    sub_title: string;
  } | null;
  pin_info: {
    token: string;
    title: string;
    bonus: null | number;
  } | null;
  store_info: {
    token: string;
    code: string;
    title: string;
  } | null;
};

export const BonusOperation = {
  PIN_PAYMENT_SALE: "pin-payment-sale",
  PIN_CASH_SALE: "pin-cash-sale",
  PRODUCT_SALE: "product-sale",
  FLIXBUS_SALE: "flixbus-sale",
  POSTPAID_CONTRACT: "postpaid-contract",
  PREPAID_CONTRACT: "prepaid-contract",
  // REPRES_CREATE_ORDER: "repres-create-order",
  // REPRES_CREATE_SALE: "repres-create-sale",
  // REPRES_MONEY_COLLECTION: "repres-money-collection",
} as const;
export type BonusOperation = (typeof BonusOperation)[keyof typeof BonusOperation];

export type Product = {
  id: number;
  token: string;
  company: string;
  site: string;
  title: string;
  type: string;
  brand: number;
  bonus: Bonus | null;
  sub_title: string;
  description: string;
  stock: number;
  canonical: string;
  slug: string;
  image_web: string;
  active: 1 | 0;
  tax_included: 1 | 0;
  currency: string | null;
  customer_price: string;
  price: string;
  created_at: string;
  is_primary: 1 | 0;
  connected_packages: { title: string; slug: string }[];
  cannonical_product: string | null;
  cannonical_product_token: string | null;
  status: number;
  reseller_price: string | null;
  dealer_price: string | null;
  tax_rate: string;
  keywords: string | null;
  serial_required: number;
  attribute: {
    attribute_id: number;
    attribute_label: string;
    attribute_value: string;
    item_id: number;
    item_value: string | null;
  }[];
  relations: Relation[];
  variants: Product[];
  categories: any[];
  available: number;
  cargo: {
    id: number;
    company: string;
    site: string;
    title: string;
    description: string;
    logo: string;
    day: string;
    fix_price: number;
    free_limit: number;
    unit_price: number;
    primary: number;
    status: number;
    created_at: string;
    updated_at: string;
  } | null;
  brand_info: {
    id: number;
    title: string;
    type: string;
    image: string;
  };
  company_info: {
    token: string;
    title: string;
  } | null;
  site_info: {
    token: string;
    title: string;
  } | null;
  cargo_info: {
    site: string;
    title: string;
    fix_price: number;
  };
  gallery: {
    product: string;
    image: string;
    order: number;
    status: number;
  }[];
  available_variants: boolean;
  min_price: string;
  min_price_slug: string;
  options: {
    label: string;
    slug: string;
    price: string;
    customer_price: string;
    image_web: string;
    image_mobile: string;
    title: string;
    sub_title: string;
  }[];
};

export type City = {
  id: number;
  country: string;
  state: string;
  name: string;
  value: number;
  latitude: string;
  longitude: string;
};

export type Country = {
  id: number;
  name: string;
  code: string;
  status: number;
  created_at: string | null;
  updated_at: string | null;
};

export type Supplier = { id: number; title: string; code: string; type: string };

/** Kart faturası ödemelerinde (store-shop-balance / store-reverse-shop-balance) fatura external'ına yazılan banka özeti. */
export type InvoicePaymentBank = {
  id: number;
  iban: string | null;
  name: string | null;
  holder: string | null;
};

export type InvoicePaymentMethod = "bank_transfer" | "balance";

export type InvoicePaymentHistoryItem = {
  action: "payment" | "reversal";
  amount: number;
  method: InvoicePaymentMethod | null;
  remark: string | null;
  user_name: string | null;
  created_at: string;
  created_by: string | null;
  from?: InvoicePaymentBank | null;
  to?: InvoicePaymentBank | null;
};

export type InvoiceExternal = {
  payment?: { method: InvoicePaymentMethod | null; remark: string | null };
  created_by?: string;
  /** Faturanın son banka hareketi (to/from null olabilir). */
  bank_transfer?: { from: InvoicePaymentBank | null; to: InvoicePaymentBank | null } | null;
  payment_history?: InvoicePaymentHistoryItem[];
  [key: string]: any;
};

export type Invoice = {
  id: number;
  company: string | null;
  buyer_site: string | null;
  site: string;
  cancel: number | string | null;
  cancel_no: string | null;
  store: string | null;
  token: string;
  locale: string;
  type: number;
  invoice_no: string;
  invoice_date: string;
  total_price: string;
  total_discount: string;
  total_vat: string;
  total_amount: number;
  store_balance: string;
  note: string;
  description_bottom: string;
  description: string;
  invoice_title: string | null;
  dates: string;
  keyword: string | null;
  paid: 1 | 0;
  mailSent: 1 | 0;
  from_to: string;
  from_bank: string | null;
  to_bank: string | null;
  status: number;
  created_at: string;
  updated_at: string;
  invoice: string;
  store_code: string;
  store_title: string;
  invoice_type: string;
  paid_price: string | null;
  seller: string;
  buyer: string;
  external?: InvoiceExternal | null;
  store_info: {
    token: string;
    code: string;
    title: string;
    cities: string;
    provision_payment_type?: InvoicePaymentMethod | null;
  } | null;
  site_info: {
    token: string;
    title: string;
  } | null;
  company_info: {
    token: string;
    title: string;
  } | null;
  buyer_site_info: {
    token: string;
    title: string;
  } | null;
  buyer_info: {
    token: string;
    title: string;
    code?: string;
  } | null;
  seller_info: {
    token: string;
    title: string;
  } | null;
};

export type Brand = {
  id: number;
  main: number | null;
  title: string;
  type: string;
  image: string;
  slug: string;
  public: number;
  rel_brand: number | null;
  status: number;
  order: number;
  created_at: string;
  updated_at: string | null;
  suppliers: any[];
  sub: any[];
};

export type SaleTypeEnum = "site_store" | "store_store" | "site_site" | "store_site" | "";

export const AllowedParams = {
  search: "search",
  title: "title",
  company: "company",
  site: "site",
  store: "store",
  status: "status",
  month: "month",
  date: "date",
  seller: "seller",
  buyer: "buyer",
  manidator: "manidator",
  type: "type",
  sale_type: "sale_type",
  user: "user",
  approved: "approved",
  email: "email",
  brand: "brand",
  label: "label",
  product_type: "product_type",
  order_id: "order_id",
  operation: "operation",
  category: "category",
  last_login: "last_login",
  state: "state",
  where: "where",
  export: "export",
  rows: "rows",
  product: "product",
  supplier: "supplier",
  order: "order",
  group: "group",
  invoice_type: "invoice_type",
  keyword: "keyword",
  payment_status: "payment_status",
  paid: "paid",
  used: "used",
  assign: "assign",
  customer: "customer",
  subscription_id: "subscription_id",
  all_site: "all_site",
  assigned_to_me: "assigned_to_me",
  my_created: "my_created",
  payout: "payout",
  representative: "representative",
  active: "active",
  return_status: "return_status",
  brand_id: "brand_id",
  return_person: "return_person",
  buyers: "buyers",
  wallet: "wallet",
  ip: "ip",
  client_id: "client_id",
  login_type: "login_type",
  payment_type: "payment_type",
  approval_status: "approval_status",
  level: "level",
  stream: "stream",
  log_group: "log_group",
  file: "file",
} as const;

export type AllowedParams = keyof typeof AllowedParams;

export type Init = {
  page_info: { title: string; icon: string; api_url: string };
  page_head: TableNav[];
  table_nav: TableNav[];
  table_head: { id?: number; value: string; title: string }[];
  rules: Record<string, boolean>;
  items: UpdateMainItem[];
};

export type TableNav = {
  id: number;
  icon: string | null;
  target: string | null;
  title: string | null;
  url: string | null;
  params: string | null;
  class: string | null;
};

export type CoreTableData = {
  status: boolean;
  message: string;
  extention: {
    align: string;
    color: null;
    text: string;
    value: string;
    width: string;
  }[];
};

export type TableData<T> = {
  data: T[];
} & CoreTableData;

export type TableDataPaginate<T> = {
  data: {
    data: T[];
    last_page: number;
    current_page: number;
    total: number;
    per_page: number;
  };
} & CoreTableData;

export type Contract = {
  id: number;
  spider_id: string;
  company: string;
  site: string;
  store: string;
  user: string;
  customer: string | null;
  operator: string | null;
  brand: number;
  processing_personnel: string | null;
  basket: string;
  gender: string;
  title: string | null;
  name: string;
  surname: string;
  birthday: string;
  id_location: string;
  id_exp_date: string;
  id_no: string;
  id_type: string;
  email: string;
  phone_country_code: string;
  phone_area_code: number | null;
  phone_number: number | null;
  sms_pass: string | null;
  postal_code: string | null;
  city: string | null;
  address: string | null;
  address_no: string | null;
  iban: string | null;
  imei: string | null;
  transfer: number;
  transfer_name: string;
  transfer_surname: string;
  transfer_birthday: string;
  transfer_company: string;
  transfer_postal_code: string | null;
  transfer_address_no: string | null;
  transfer_address: string | null;
  transfer_city: string | null;
  sim_card_number: string | null;
  sim_password: string | null;
  provider: string;
  customer_type: string | null;
  previous_provider: string | null;
  document_url: string | null;
  coupon: string | null;
  contract_no: string | null;
  type: string;
  sim_card_date: string;
  ip: string;
  contract_data: string | null;
  note: string | null;
  technical_retry: number;
  retry: number;
  i_agree: string | null;
  i_check1: string | null;
  i_check2: string | null;
  b2c: number;
  active: number;
  commission_invoice: string | null;
  store_invoice: string | null;
  subscription_id: string;
  instruction_id: string;
  payment_status: number;
  status: number;
  comment: string;
  contract_type: string;
  delivery_type: string | null;
  result_at: string | null;
  identity_front: string | null;
  identity_back: string | null;
  bank_card_front: string | null;
  bank_card_back: string | null;
  auftrag_doc: string | null;
  contract_doc: string | null;
  created_at: string;
  updated_at: string;
  order: string | null;
  products: ContractProduct[];
  total_provision: number;
  user_info: string | null;
  company_info: {
    token: string;
    title: string;
  } | null;
  site_info: {
    token: string;
    title: string;
  } | null;
  store_info: {
    token: string;
    title: string;
    code: string;
  } | null;
};

export type NewContract = {
  id: number;
  sim_card_date: string | null;
  comment: string;
  name: string;
  surname: string;
  operator: string | null;
  subscription_id: string;
  phone_number: string;
  phone_country_code: string;
  contract_type: string;
  phone_area_code: string;
  type: "newAyyildizContract" | "manuelAyyildizContract";
  status: number;
  site: string;
  contract_no: string;
  payment_status: number;
  note: string;
  identity_front: string;
  identity_back: string;
  bank_card_front: string;
  bank_card_back: string;
  contract_doc: string;
  auftrag_doc: string;
  provider: string;
  basket: string;
  brand: number;
  store: string;
  products: {
    token: string;
    type: string;
    title: string;
    sub_title: string;
    dealer_price: string;
    keywords: string;
    slug: string;
  }[];
  total_provision: number;
  invoice: string;
  invoice_paid: string;
  user_info: string;
  company_info: string;
  site_info: {
    token: string;
    title: string;
  };
  store_info: {
    token: string;
    title: string;
    code: string;
  };
  brand_info: {
    id: number;
    title: string;
  };
};

type ContractProduct = {
  token: string;
  type: string;
  title: string;
  sub_title: string;
  dealer_price: string;
  keywords: string;
  slug: string;
};

export type TariffData = {
  operator: string;
  operator_gain: number;
  logo: string;
  product: Product;
  packages: Product[];
}[];

type Relation = {
  id: number;
  site: string;
  product: string;
  rel_id: number | null;
  rel_product: string;
  order: number | null;
  main: number | null;
  status: number;
  created_at: string;
  updated_at: string;
  title: string;
  sub_title: string;
  customer_price: string;
  reseller_price: string;
  keywords: string;
  description: string;
  tax_included: 1 | 0;
  tax_rate: string;
  price: string;
};

export type Pin = {
  id: number;
  bonus: Bonus | null;
  token: string;
  brand: number | null;
  type: number;
  title: string;
  price: number;
  discount: string;
  income_tax: number;
  vat: string;
  content: string;
  free_access_number: null;
  mobile_access_number: null;
  load_prefix: string;
  local_access_number: null;
  telephone: null;
  customer_service: null;
  api_service: number;
  api_id_new: number;
  api_id: number;
  api_danger: number;
  api_limit: number;
  photo: string;
  order: number;
  banner: null;
  category: string;
  stock: number;
  loading: number;
  visible: number;
  status: number;
  auto_load: number;
  created_at: string;
  updated_at: string;
  brand_info: {
    id: number;
    main: null;
    title: string;
    type: string;
    image: string;
    slug: string;
    public: number;
    rel_brand: null;
    status: number;
    order: null;
    created_at: string;
    updated_at: string;
  } | null;
  api_info: {
    id: number;
    title: string;
    url: string;
    params: null;
    auto: number;
    user: string;
    pass: string;
    auth: string;
    status: number;
    created_at: string;
    updated_at: string;
  };
};

export type DiscountCode = {
  id: number;
  brand: number;
  type: string;
  code: string;
  status: number;
  created_at: string;
  updated_at: string;
  brand_info?: {
    id: number;
    title: string;
  };
};

export type PinDetail = {
  pin_brand: number;
  pin_type: number;
  bonus: Bonus | null;
  pin_title: string;
  pin_price: number;
  pin_photo: string;
  pin_content: string;
  load_prefix: string;
  api_service: number;
  token: string;
  company: string;
  site: string;
  store: string;
  stock: number;
  commission: number;
  store_stock: number;
  company_balance: number;
  company_credit: number;
  site_balance: number;
  site_credit: number;
  balance: string;
  credit: number;
  available: number;
  company_price: number;
  cost_price: number;
  site_price: number;
  store_price: number;
  value_price: number;
  store_discount: string;
  site_discount: string;
  vat_percent: number;
  vat_price: number;
  category: string;
  auto_load: number;
  need_confirmation: boolean;
};

export type Basket = {
  id: number;
  company: string | null;
  site: string;
  store: string;
  basket_code: string;
  customer_type: string;
  payment_type: string;
  currency: string;
  user: string;
  email: string;
  ip: string;
  amount: number;
  tax_percent: number;
  total_tax: number;
  net_price: number;
  gross_price: number;
  discount: number;
  discountless_price: number;
  zipcode: null;
  address: null;
  cargo_firm: string;
  cargo_price: number;
  cargo_meters: null;
  cargo_code: null;
  billed: number;
  invoice: null;
  invoice_no: string;
  note: null;
  basket_status: number;
  slug: string;
  status: number;
  created_at: string;
  updated_at: string;
  items: Array<BasketItem>;
  shipping: any;
  addressDetail: any;
  discount_detail: null;
  statusText: string;
  for_free_cargo: number;
  cargo_fix_price: number;
  user_info: any;
  site_info: any;
};

type BasketItem = {
  id: number;
  company: string | null;
  site: string;
  basket: number;
  customer_note: (string | null)[] | null;
  serial: null;
  product: string;
  amount: number;
  type: string;
  unit_type: string;
  unit_price: string;
  purchase_price: string;
  description: null;
  provision: string | null;
  tax_rate: string;
  tax_included: 1 | 0;
  visible: number;
  deleted: number;
  created_at: string;
  updated_at: string;
  info: {
    bonus: Bonus | null;
    token: string;
    title: string;
    brand: number;
    sub_title: string;
    customer_price: string;
    cargo_info: null;
    image_web: string;
    stock: number;
    keywords: string[];
    price: string;
    type: string;
    description: string;
    gallery: Array<{
      product: string;
      image: string;
      order: number;
      status: number;
    }>;
    company_info: null;
    site_info: null;
    brand_info: {
      id: number;
      main: null;
      title: string;
      type: string;
      image: string;
      slug: string;
      public: number;
      rel_brand: null;
      status: number;
      order: null;
      created_at: string;
      updated_at: string;
    };
  };
  min_order: number;
  max_order: number;
  calculated_price: number;
  calculated_bonus: number;
  base_price: number;
};

export type Confirm = {
  titleAndText: { title?: string; text?: string | React.ReactNode };
  open: any;
  no: () => void;
  yes: () => void;
  buttonText?: { no: string; yes: string };
  loading?: boolean;
};

export type InvoiceRowData = {
  created_at: string;
  id: number;
  supplier_title: string;
  site_title: string;
  invoice_date: string;
  invoice_type: string;
  invoice_no: string;
  invoice_tax_rate: number;
  net_price_with_tax: number;
  net_price_without_tax: number;
  tax_price: number;
  net_provision_price_with_tax: number;
  net_provision_price_without_tax: number;
  provision_tax_price: number;
  provision_tax_rate: number;
  total_price: number;
  total_provision: number;
  invoice_total: number;
  remark: string;
  document: {
    id: number;
    cdn_url: string;
    href: string;
  };
  userInfo: {
    token: string;
  } | null;
  paid: 1 | 0;
  bank: BanksType | null;
  site: string;
  late_period: 0 | 1 | 2;
};

export type Order = {
  token: string;
  title: string;
  status: number;
  invoice: string;
  proforma: string;
  from: string;
  to: string;
  id: number;
  basket: number;
  type: number;
  sale_type: SaleTypeEnum;
  site_informations: { title: string } | null;
  basket_info: any;
  seller: string;
  buyer: string;
  has_invoice: 1 | 0;
  note: string;
  order_type: string;
  address: StoreAddress | null;
  buyer_keyword: string;
  proforma_invoice_price: number;
  proforma_invoice_paid: 1 | 0;
  proforma_invoice_no: string;
  auto_cargo: 1 | 0;
};

export type OrderBasket = {
  items: {
    site: string;
    product: {
      token: string;
      type: string;
      title: string;
      sub_title: string;
      image_web: string;
      image_mobile: string;
      brand: number;
      serial_required: number;
      bonus: null;
      items: { id: number; serial: null | string; site: string; phone_no: null; supplier_id: number; cost_price: string; bonus: number }[];
    };
    purchase_price: string;
    total_amount: number;
    has_seri_no: number;
    has_no_seri_no: number;
    description: string;
    sent_stop: number;
  }[];
  amount: number;
  price_history: {
    product: string;
    product_title: string;
    price_histories: { supplier_id: number; supplier_title: string; histories: { price: string; uploaded_at: string }[] }[];
  }[];
};

export type OrderBasketItem = OrderBasket["items"][number];

export type Cargo = {
  id: number;
  title: string;
  description: string;
  logo: string;
  day: string;
};

export type DeliveryCustomer = {
  token: string;
  name: string;
  phone: string | null;
  email: string | null;
  city: number | null;
  city_information: {
    name: string;
  } | null;
  address: string | null;
  house_number: string | null;
  postal_code: string | null;
};

export type CreateDeliveryForm = {
  customer: DeliveryCustomer | null;
  cargo: string;
  box_type: string;
  cargo_no: string;
  delivery_no: string;
  note: string;
};

export type PrintDeliveryType = {
  delivery_no: string;
  cargo_info?: {
    title: string;
    cargo_no: string | null;
  };
  customer_info?: {
    name: string;
    address: string | null;
    house_number: string | null;
    postal_code: string | null;
    phone?: string | null;
    email?: string | null;
  };
};

export type Delivery = {
  customer: string;
  token: string;
  cargo_firm_id: number;
  cargo_firm: string;
  box_type: string;
  cargo_no: string | null;
  delivery_no: number | null;
  note: string | null;
  address: string | null;
  house_number: string | null;
  postal_code: string | null;
  city: string | null;
  status: number;
};

export type SalePinReprint = {
  pinCode: string;
  pinSerial: string;
  category: string;
  pinPurchase: number;
  brand: number;
  type: number;
  title: string;
  title_2: string;
  content: string;
  content_clean: string;
  price: number;
  discount: number;
  lahmacun: string;
  vat: number;
  FreeAccessNumber: string;
  MobileAccessNumber: string;
  LocalAccessNumber: string;
  Telefonzelle: string;
  CustomerService: string;
  load_prefix: string;
  photo: string;
  pinDate: string;
  pinTime: string;
  qr: number;
  store_info: Store;
  detail: any;
};

export type SalePin = {
  order: number;
  status: boolean;
  pinCode: string;
  pinSerial: string;
  pinPurchase: number;
  commission: number;
  codeDate: string;
  brand: number;
  type: number;
  title: string;
  price: number;
  photo: string;
  content: string;
  content_clean: string;
  load_prefix: string;
  qr: number;
  discount: string;
  vat: number;
  pinDate: string;
};

export type User = {
  id: number;
  company: string;
  site: string;
  token: string;
  authority: Array<string>;
  type: number;
  chief: null;
  opus: number;
  receiver: number;
  representative: number;
  boss: number;
  trusty: number;
  employe: number;
  user: number;
  customer: null;
  user_code: string;
  username: null;
  name: string;
  surname: null;
  email: string;
  email_verified_at: null;
  reset_method: string;
  login_method: string;
  phone: string;
  gender: null;
  store_code: string;
  level: number;
  ip: string;
  old_ip: string;
  confirmation: null | string;
  waiting: number;
  photo: null;
  kvkk: number;
  signature: string;
  status: number;
  balance: string;
  keyword: null;
  captcha_required: number;
  delivery_type: null;
  last_login_at: string;
  created_at: string;
  updated_at: string;
  auth_group: string;
  auth_id: number;
  demcas_user: boolean;
  bonus_interval: number;
  site_informations: {
    title: string;
    token: string;
  } | null;
};

export type StoreCargo = {
  cargo_id: number;
  cargo_title: string;
  primary: number;
};

export type Visit = {
  id: number;
  site: string;
  store: string;
  user: string;
  started_at: string;
  ended_at: string;
  start_geo_x: string;
  start_geo_y: string;
  end_geo_x: string;
  end_geo_y: string;
  ip: string;
  rep_note: string;
  visit_note: string;
  created_at: string;
  survey: number;
  balance: number;
  sales: number;
  order: number;
  visit_duration: string;
  store_info: { token: string; title: string; last_visit_at: string; user_name: string; code: string; city_detail: string };
  site_info: { token: string; title: string };
  user_info: { token: string; name: string };
};

export type StoreOrder = {
  id: number;
  user: string;
  note: string;
  order_type: string;
  proforma: string;
  invoice: string;
  invoice_no: string;
  amount: number;
  price: number;
  created_at: string;
  status: number;
};

export type StoreOrderDetail = {
  from: string;
  to: string;
  order_id: number;
  note: string;
  invoice: string;
  arrival_date: string;
  created_at: string;
  total_price: number;
  status: number;
  items: {
    product: string;
    amount: number;
    price: number;
    customer_note: string | null;
  }[];
  address: StoreAddress | null;
  delivery_info: {
    country: string;
    city: string | null;
    geo_x: string | null;
    geo_y: string | null;
    address_1: string;
    address_2: string;
    postal_code: string;
    phone: string;
  };
};

export type StoreAddress = {
  id: number;
  title: string;
  name: string;
  phone: string;
  email: string;
  country: number;
  country_info: { name: string };
  city: number;
  city_info: { name: string };
  address_1: string;
  address_2: string;
  postal_code: string;
};

export type ShopTableData = {
  summary(summary: any): unknown;
  data: {
    table: ShopAccount[];
    summary: Record<string, number>;
  };
  total: number;
  current_page: number;
  per_page: number;
  last_page: number;
};

type ShopAccount = {
  created_at: string;
  type: string;
  user: string | null;
  icon: string | null;
  invoice_no: string;
  invoice_token: string;
  template: string;
  total_price: number | null;
  provision: number;
  site: string;
  status: number;
  pdf: string;
  payment: string;
  avis: string | null;
  datum: string | null;
  transfer: string;
  bank: string;
  from_bank: string | null;
  to_bank: string | null;
  note: string;
  keyword: string;
  external: {
    avis: string;
    created_by: string;
    invoice_no: string;
  };
  avis_no: string;
  collected_at: string | null;
};

export const RepresentativeBonusOperation = {
  MONTHLY_SALE: "monthly-sale",
  MONTHLY_ORDER: "monthly-order",
  MONTHLY_STORE_VISIT: "monthly-store-visit",
  MONTHLY_COLLECTION: "monthly-collection",
  NEW_CUSTOMER: "new-customer",
  NEW_CUSTOMER_PIN_INVOICE: "new-customer-pin-invoice",
  NEW_CUSTOMER_SIM_INVOICE: "new-customer-sim-invoice",
} as const;
export type RepresentativeBonusOperation = (typeof RepresentativeBonusOperation)[keyof typeof RepresentativeBonusOperation];

export type BonusRule = {
  id: number;
  operation: RepresentativeBonusOperation;
  step: number;
  value: number;
  brand: number | null;
  brand_info: Brand | null;
};

export type BonusHistory = {
  id: number;
  operation: RepresentativeBonusOperation | "payout";
  representative: string;
  step: number;
  value: number;
  brand: number | null;
  store: string;
  bonus_info: string;
  created_at: string;
  updated_at: string;
  store_info: {
    token: string;
    code: string;
    title: string;
  };
  representative_info: {
    token: string;
    name: string;
  };
  brand_info: Brand | null;
  note: string | null;
};

export type RefundRequestPin = {
  id: number;
  user_name: string;
  store_code?: string;
  store_title?: string;
  store_note: string | null;
  note: string;
  status: number;
  refund_reason: string;
  pin: string;
  pin_code: string;
  pin_title: string;
  seri_no?: string | null;
  buy_price: string;
  return_price: string;
  resolved_at: string | null;
  created_at: string;
  sale_id: number;
  sale_status: number;
};

export type Note = {
  id: number;
  site: string;
  site_info: { title: string } | null;
  note: string;
  subject: string;
  created_at: string;
  updated_at: string;
};

export type DefectiveProduct = {
  id: number;
  user: string;
  company: string;
  buyed_from: string;
  site: string;
  store: string;
  basket_code: string;
  representative: string;
  return_person: string;
  assigned_by: string;
  product: string;
  seri_no: string;
  sim_no: string;
  phone_number: string;
  processing_personnel: string;
  cost_price: string;
  company_price: string;
  site_price: string;
  store_price: string;
  sent_stop: number;
  active: number;
  in_basket: number;
  sold: number;
  note: string;
  control_status: number;
  sale_status: number;
  status: number;
  assign_date: string;
  amount: number;
  sale_date: string;
  upload_no: number;
  supplier_id: string;
  document: number;
  created_at: string;
  updated_at: string;
  product_title: string;
  return_person_name: string;
  brand_title: string;
  site_title: string;
};

export type DefectiveStock = {
  id: number;
  user: string;
  company: string | null;
  buyed_from: string | null;
  site: string;
  store: string | null;
  basket_code: string | null;
  representative: string | null;
  return_person: string | null;
  return_person_info: {
    name: string;
  } | null;
  assigned_by: string | null;
  product: string;
  seri_no: string;
  sim_no: string | null;
  phone_number: string | null;
  processing_personnel: string | null;
  cost_price: string | null;
  company_price: string | null;
  site_price: string;
  store_price: string | null;
  sent_stop: number;
  active: number;
  in_basket: number;
  sold: number;
  note: string | null;
  status: number;
  assign_date: string | null;
  sale_date: string;
  control_status: number;
  sale_status: number;
  return_status: number;
  amount: number;
  supplier_id: string | null;
  upload_no: number;
  document: number;
  created_at: string | null;
  updated_at: string | null;
  product_info: {
    token: string;
    title: string;
    sub_title: string;
    brand_info: null;
  };
  company_information: null;
  site_information: null;
};

export type Wallet = {
  id: number;
  user: {
    token: string;
    id: number;
    name: string;
    email: string;
  };
  operation_type: string;
  operation: string;
  payment_type: string;
  incoming_price: number | null;
  outgoing_price: number;
  balance: number;
  old_balance: number;
  confirm: number;
  remark: string;
  paid_date: string;
  image: string;
  created_at: string;
  type: number;
  wallet_name: string;
  title: string;
  token: string;
  system_message: string;
};

export type ContractRow = {
  id: number;
  code: string;
  title: string;
  product: string;
  product_name: string;
  type: string;
  start_date: string;
  end_date: string;
  month_status: string;
  price: number | null;
  status: string;
};

export type ContractDetail = {
  id: number;
  store: string;
  product_name: string;
  type: string;
  start_date: string;
  end_date: string;
  price: number | null;
  status: string;
  passed_months: string;
  remaining_months: string;
  progress_percent: number;
  document: Document | null;
  items: {
    id: number;
    price: string;
    status: string;
    due_date: string;
  }[];
  attachments: Document[];
};

export type ContractForm = {
  file: File | null;
  fileId: number | null;
  store: Store | null;
  customer: {
    name: string;
    store_name: string;
    address: string;
    zip: string;
    city: string;
    country: string;
    customer_no: string;
    contact_person: string;
    phone: string;
    email: string;
  };
  type: "pin" | "webshop";
  installation_fee_product: Product | null;
  installation_fee_discount: number;
  installation_fee_final_price: number;
  start_date: string;
  duration_months: number;
  end_date: string;
  product: Product | null;
  seri_no: string;
  prices: { month: number; price: number; status: "Geplant" | "Fakturiert"; rechnungsnr: string }[];
  note: string;
  tags: string[];
  attachments: { file: File; id: number }[];
};

export type Document = {
  id: number;
  site: string;
  href: string;
  group: null;
  type: null;
  mime: string;
  width: string;
  height: string;
  size: number;
  keyword: null;
  cdn_url: string;
  created_at: string;
  updated_at: string;
};

export type PinStatisticDay = {
  date: string;
  amount: number;
};

/** pin-statistic/{token}?start=&end= */
export type PinStatistic = {
  pin: string;
  pin_title: string;
  start: string;
  end: string;
  total_sales: number;
  daily_average: number;
  weekday: { total_sales: number; daily_average: number };
  weekend: { total_sales: number; daily_average: number };
  days: PinStatisticDay[];
  min_buy_amount?: number | null;
  max_buy_amount?: number | null;
};

/** pin-autocash-prices liste elemanı. Discount'lar API'den string ("2.4000") gelir. */
export type PinAutocashPrice = {
  pin_token: string;
  pin_title: string;
  pin_price: number;
  /** pin_price × (1 − default_cost_discount / 100) */
  cost_price: number;
  brand_id: number;
  brand_name: string;
  /** Diğer indirimlerden farklı olarak sayı döner. */
  default_cost_discount: number;
  default_company_discount: string;
  default_site_discount: string;
  default_store_discount: string;
};

/** PUT pin-autocash-prices/{pin_token} gövdesi */
export type PinAutocashPriceUpdate = {
  /** Demcom'un ana alış oranı (%) */
  cost_discount: number;
  company_discount: number;
  site_discount: number;
  store_discount: number;
};

/** pj-pin-purchase cevabı (data.data) */
export type PinPurchaseResult = {
  order_id: number;
  transid: number;
  total_count: number;
  success_count: number;
  error_count: number;
  success_list: { code: string; purchase_price: string }[];
  error_list: { code?: string; reason?: string }[];
};
